import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const GrowNeutral = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <circle cx={8} cy={8} r={8} fill="#2C2A2A" fillOpacity={0.2} />
      <path stroke="#4E4E4F" strokeLinecap="round" d="M4 8h9" />
    </svg>
  );
};
export default GrowNeutral;
